export default function(message, info) {
  this.message = message;
  this.info = info; // for additional information
}
